exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-templates-page-js": () => import("./../../../src/templates/page.js" /* webpackChunkName: "component---src-templates-page-js" */),
  "slice---src-slices-blank-index-tsx": () => import("./../../../src/@slices/blank/index.tsx" /* webpackChunkName: "slice---src-slices-blank-index-tsx" */),
  "slice---src-slices-modules-lift-ticket-section-v-0-index-tsx": () => import("./../../../src/@slices/modules/liftTicketSection-v0/index.tsx" /* webpackChunkName: "slice---src-slices-modules-lift-ticket-section-v-0-index-tsx" */)
}

